import { OutputHTMLElement } from "components/output/baseHTMLElementOutput";
import { EnumDateOutputType } from "components/output/dateFormats";
import template from "components/output/baseInputOutput.hbs";
import moment from "moment";

export class DateTimeOutputElement extends OutputHTMLElement {

  constructor() {
    super();

    let className = "c-datetime-output__input o-form-component__output o-form-component__input-group__input";
    const classCSSOutput = this.getAttribute("classCSSOutput");
    if (classCSSOutput) {
      className += " " + classCSSOutput;
    }

    const optTemplate = {
      "prefixId": "dto",
      "id": this.getAttribute("_id"),
      "className": className,
      "disableFocusKeyboard": (this.getAttribute("disableFocusKeyboard") === 'true'),
    } as any;

    this.innerHTML = template(optTemplate);

    this.input = this.querySelector("input");
  }

  public isEqualToInitialValue(value: any): boolean {
    let isEqual: boolean = true;
    const initialValue = this.initialValue.value;

    isEqual = this.isEqualForDate(value, initialValue, 'seconds');

    return isEqual;
  }

  private doFormat(dateTimeSelected: Date): string {
    let value = "";

    if (dateTimeSelected != null) {
      value = this.getFormat().format(dateTimeSelected);
      //Fix: Spanish format add ',' separating blocks, date and time: It´s not in our mask, so we will remove it
      value = value.replace(/, /g, " ");
    }

    return value;
  }

  private getFormat(): Intl.DateTimeFormat {
    return EnumDateOutputType.getIntlDateTimeFormat(EnumDateOutputType.dateTime);
  }

  get data(): Date {
    let tzDate = this.input.value as string;
    if (tzDate != null) {
      const date = moment.utc(tzDate, EnumDateOutputType.getFormatterPattern(EnumDateOutputType.dateTime));
      if (date.isValid()) {
        return date.toDate();
      }
    }
    return null;
  }

  set data(v: Date) {
    this.input.value = this.doFormat(v) ?? null;
    this.initialValue.value = this.data;
  }

}

export function initDateTimeOutputWebComponent() {
  window.customElements.define("s6-date-time-output", DateTimeOutputElement);
}
